export default __webpack_public_path__ + "static/media/freeParking.57bdac07.png";